import { CollapseItem } from './components/collapseItem/CollapseItem'
import { InnerList } from './components/innerList/InnerList'
import { Item } from './components/item/Item'
import { Label } from './components/label/Label'
import { Separator } from './components/separator/Separator'
import { SubList } from './components/subList/SubList'
import { IListProps } from './models'

export const List = ({ children, ...restProps }: IListProps) => (
  <InnerList {...restProps}>{children}</InnerList>
)

List.Separator = Separator
List.Item = Item
List.Label = Label
List.SubList = SubList
List.CollapseItem = CollapseItem
